import Image from 'next/image';
import { type FC } from 'react';

import { Box, Stack } from '@craft/ui/components/structural';

import { getPublicLogoPath } from '@/src/config';

export const HeaderLogo: FC = () => (
  <Stack direction='row' id='main-logo'>
    <Box sx={{ display: { sm: 'none', xs: 'contents' } }}>
      <Image
        alt='craft education logo'
        height={38}
        loading='eager'
        preload
        src={getPublicLogoPath('white-brandmark.png')}
        style={{ height: '100%', maxHeight: '100%', width: 'auto' }}
        width={44}
      />
    </Box>
    <Box sx={{ display: { sm: 'contents', xs: 'none' } }}>
      <Image
        alt='craft education logo'
        height={38}
        loading='eager'
        preload
        src={getPublicLogoPath('white-logo.svg')}
        style={{ height: '100%', maxHeight: '100%', width: 'auto' }}
        width={145}
      />
    </Box>
  </Stack>
);
